import { render } from "./CategorySchemajson.vue?vue&type=template&id=2232bad6"
import script from "./CategorySchemajson.vue?vue&type=script&lang=js"
export * from "./CategorySchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__